
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Die Inkubationszeit des neuen Coronavirus, das heisst die Zeitspanne zwischen
der Ansteckung und dem Auftreten der ersten Symptome, beträgt etwa drei bis
sieben Tage. Sie kann jedoch bis zu 14 Tage dauern. Im Schnitt beträgt sie 5 bis 6 Tage (Median).
Wenn man an einer viralen Atemwegserkrankung leidet, ist man in der Regel dann
am ansteckendsten, wenn man die stärksten Symptome hat. Beim neuen Coronavirus
könnte das anders sein. Man ist möglicherweise bereits vorher
ansteckend: unmittelbar bevor Symptome auftreten.
Eine `}<Link disco href='https://cmmid.github.io/topics/covid19/control-measures/pre-symptomatic-transmission.html' mdxType="Link">{`Studie`}</Link>{` stützt diese These, `}<strong parentName="p">{`gemäss ihr geschehen 25 bis 30% der Ansteckungen in der Phase, wo der Erkrankte keine Symptome hat.`}</strong>{` Eine `}<Link disco href='https://www.medrxiv.org/content/10.1101/2020.03.05.20031815v1' mdxType="Link">{`andere Studie`}</Link>{` sieht diese Werte sogar bei 48% (für Singapur) und 62% (für China).
Eine `}<Link disco href='https://www.medrxiv.org/content/10.1101/2020.03.15.20036707v2.full.pdf' mdxType="Link">{`dritte Studie`}</Link>{` schätzt, dass 44% der Ansteckungen geschehen, noch bevor Symptome entwickelt wurden.`}</p>
    <p>{`Die WHO sagt hingegen: Bei Covid-19 seien zwar Übertragungen 24 bis 48 Stunden vor dem Auftreten von Symptomen bekannt, sie seien aber nach derzeitigem Kenntnisstand anders als bei der Grippe selten und spielten für die Weiterverbreitung kaum eine Rolle. Eine Übertragung vor dem Auftreten von Symptomen lässt sich nur schwer kontrollieren. Bei Sars war das anders. Da passierte die Übertragung fast ausschliesslich von Menschen mit Symptomen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;